"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linearStringArrayInterpolation = exports.interpolate = void 0;
const common_1 = require("@finley-technologies/common");
const deserializeInputToNumberArray = (input) => {
    try {
        (0, common_1.finleyAssert)(typeof input === 'string', 'LINEARSTRINGARRAYINTERPOLATION: xValuesString must be string');
        const numberArray = JSON.parse(input);
        (0, common_1.finleyAssert)(common_1.typeguards.isNumberArray(numberArray), 'LINEARSTRINGARRAYINTERPOLATION: Unable to deserialize input to number array.');
        return numberArray;
    }
    catch (err) {
        (0, common_1.debugLog)(`LINEARSTRINGARRAYINTERPOLATION: Unable to deserialize [input:${input}]to number array.`, err);
        throw new common_1.error.FinleyError(`LINEARSTRINGARRAYINTERPOLATION: Unable to deserialize [input:${input}]to number array.`);
    }
};
// exported for test purposes
const interpolate = ({ interpolationInput, xValues, yValues, }) => {
    // Ensure input arrays are of the same length
    if (xValues.length !== yValues.length || xValues.length < 2) {
        throw new common_1.error.FinleyError('LINEARSTRINGARRAYINTERPOLATION: xValues and yValues must have the same length and at least two points.');
    }
    // Find the interval in which interpolationInput lies
    // eslint-disable-next-line no-restricted-syntax
    for (let idx = 0; idx < xValues.length - 1; idx += 1) {
        const x0 = xValues[idx];
        const x1 = xValues[idx + 1];
        (0, common_1.finleyAssert)(x0 !== x1, `LINEARSTRINGARRAYINTERPOLATION: Division by zero error: xValues contains duplicate values at indices ${idx} and ${idx + 1}.`);
        if (interpolationInput >= x0 && interpolationInput <= x1) {
            const y0 = yValues[idx];
            const y1 = yValues[idx + 1];
            // Linear interpolation formula: y = y0 + (y1 - y0) * (x - x0) / (x1 - x0)
            return y0 + ((y1 - y0) * (interpolationInput - x0)) / (x1 - x0);
        }
    }
    throw new common_1.error.FinleyError(`LINEARSTRINGARRAYINTERPOLATION: input [value:${interpolationInput}] must fall within xValues range.`);
};
exports.interpolate = interpolate;
/**
 * linearStringArrayInterpolation operates on a numerial input, then two serialized (stringified) number arrays
 * the string arrays are serialized such that we can easily author in CA and store this in csv
 */
const linearStringArrayInterpolation = ({ interpolationInput, xValuesString, yValuesString, }) => {
    (0, common_1.finleyAssert)(typeof interpolationInput === 'number', 'LINEARSTRINGARRAYINTERPOLATION: interpolationInput must be number');
    const xValues = deserializeInputToNumberArray(xValuesString);
    const yValues = deserializeInputToNumberArray(yValuesString);
    return (0, exports.interpolate)({ interpolationInput, xValues, yValues });
};
exports.linearStringArrayInterpolation = linearStringArrayInterpolation;
//# sourceMappingURL=linearStringArrayInterpolation.js.map